import { render, staticRenderFns } from "./OtherUserSafetyConfirmDetail.vue?vue&type=template&id=8c9345b6&scoped=true&lang=pug"
import script from "./OtherUserSafetyConfirmDetail.vue?vue&type=script&lang=ts"
export * from "./OtherUserSafetyConfirmDetail.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserSafetyConfirmDetail.vue?vue&type=style&index=0&id=8c9345b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9345b6",
  null
  
)

export default component.exports